export default "__VITE_ASSET__OnhHWSC___"